<template>
  <div class="h-description">
    <div class="h-description-title" v-if="title">
      <span>{{ title }}</span>
      <span>
        <slot name="operation"></slot>
      </span>
    </div>
    <slot name="header"></slot>
    <div class="h-description-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "HDescription",
  props: {
    title: {
      type: String,
      default: "",
    },
    column: {
      type: Number,
      default: 3,
    },
  },
  provide() {
    return {
      column: this.column,
    };
  },
};
</script>

<style lang="scss" scoped>
.h-description {
  width: 100%;
  .h-description-title {
    width: inherit;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .h-description-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    box-sizing: border-box;
  }
}
</style>





// WEBPACK FOOTER //
// src/gtn/components/HDescription/HDescription.vue